import { OyResponse } from '@oy/types';
import { ACCOUNTING_PLATFORM } from 'src/clients';
import { IntegrationPlatformType } from './Connect';

export const CONNECTION_STATUS_URL = `${ACCOUNTING_PLATFORM}/connection-status`;

export type ConnectionStatusData = {
  platform: IntegrationPlatformType | null;
};

export type ConnectionStatusResponse = OyResponse<ConnectionStatusData>;

export type RedirectParams = {
  platform: IntegrationPlatformType;
  code: string | null;
  accessToken: string | null;
  session_state: string | null;
  state: string | null;
  scope: string | null;
  username: string;
};
